import { all } from 'redux-saga/effects';
import auth from './auth.sagas';
import shared from './shared.sagas';

export default function* rootSaga() {
  yield all([auth(), shared()]);
}
